import React from 'react';
import { useGeneralHooks } from '../../../../../Hooks/hooks';
import { IGetMe} from '../../../../../Interfaces/responseTypes';
import AuthInput from '../../../../Inputs/AuthInput/authInput';
import useUserDataHooks from './useuserData-hooks';
import TelInput from '../../../../Inputs/TelInput/telInput';
import { ButtonTypes } from '../../../../../Interfaces/componentTypes';
import Button from '../../../../Button/button';
import { UserDataIcon } from '../../../../../Assets/Icons';
import styles from './userDataDialog.module.scss';

interface IProps {
    user: IGetMe,
    onClose: () => void
}

const UserDataDialog: React.FC<IProps> = ({ user, onClose }) => {
    const { register, control, errors, onCloseDialog, handleSubmit, onSubmit,isLoading } = useUserDataHooks(onClose);
    const {t} = useGeneralHooks();   
   
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div>
                <img src={UserDataIcon} alt='UserDataIcon' />
                <p>{t('Home.User_Drawer.Data')}</p>
                </div>
            </div>
            <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
                <AuthInput
                    register={register}
                    registerName='first_name'
                    label={t('Input_Labels.Name')}
                    error={errors.first_name}
                    required={true}
                />
                <AuthInput
                    register={register}
                    registerName='last_name'
                    label={t('Input_Labels.Surname')}
                    error={errors.last_name}
                    required={true}
                />
                <TelInput
                    name='phone_number'
                    control={control}
                    label={t('Input_Labels.Phone')}
                    error={errors.phone_number}
                />
                <div className={styles.buttonsRow}>
                    <Button
                        type='button'
                        buttonType={ButtonTypes.Secondary}
                        title={t('Buttons.Close')}
                        onClick={onCloseDialog}
                        buttonStyle={styles.closeButton}
                        buttonTitleStyle={styles.buttonTitle}
                    />
                    <Button
                        type='submit'
                        buttonType={ButtonTypes.Primery}
                        title={t('Buttons.Save')}
                        isLoading={isLoading}
                        buttonStyle={styles.button}
                        buttonTitleStyle={styles.buttonTitle}
                    />
                </div>
            </form>
        </div>
    )
}

export default UserDataDialog
